import * as React from 'react';
import cx from 'classnames';
import { getBrowserDetails } from 'utils/userAgentUtils';
import pinch from 'images/chat/pinch.svg';
import pinchBlue from 'images/chat/pinch-blue.svg';
import styles from './MessageBubble.css';
export var MessageBubbleTheme;
(function (MessageBubbleTheme) {
    MessageBubbleTheme["LIGHT"] = "light";
    MessageBubbleTheme["DARK"] = "dark";
})(MessageBubbleTheme || (MessageBubbleTheme = {}));
class MessageBubble extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { isReceivedMessage, showBubblePointer, className, theme, children } = this.props;
        const messageBubbleTheme = theme || (isReceivedMessage ? MessageBubbleTheme.LIGHT : MessageBubbleTheme.DARK);
        const browserDetails = getBrowserDetails();
        const isFirefox = browserDetails.name === 'Firefox';
        return (<div className={cx({
            [styles['sent-message']]: !isReceivedMessage,
            [styles['received-message']]: isReceivedMessage,
            [styles['extra-bottom-margin']]: showBubblePointer && isFirefox,
            [styles['extra-top-margin']]: showBubblePointer && !isFirefox
        }, styles['message-bubble'], styles[`${messageBubbleTheme}-theme`], className)}>
				{showBubblePointer && (<img className={cx(styles['message-bubble-pointer'], {
            [styles['received-message-bubble-pointer']]: isReceivedMessage,
            [styles['sent-message-bubble-pointer']]: !isReceivedMessage
        })} src={messageBubbleTheme === MessageBubbleTheme.LIGHT ? pinch : pinchBlue}/>)}

				{children && (<div className={cx(styles['message-content-container'], {
            [styles['all-corners-rounded']]: !showBubblePointer
        })}>
						{children}
					</div>)}
			</div>);
    }
}
MessageBubble.defaultProps = {
    isReceivedMessage: true,
    showBubblePointer: false
};
export default MessageBubble;
